import React from "react";
import { Link } from "react-router-dom";

const CONTACT_EMAIL = "yayadentalclinic@gmail.com";

// Developer credit shown in the bottom bar. Change the URL here if needed.
const CREDIT_NAME = "Njuguna";
const CREDIT_URL = "https://njuguna.dev/articles/your-website-is-its-front-desk";

const BOOK_HREF = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
  "Appointment request"
)}`;

const QUICK_LINKS = [
  { label: "Home", to: "/" },
  { label: "Our Services", to: "/services" },
  { label: "Our Team", to: "/our-team" },
  { label: "Book an Appointment", href: BOOK_HREF },
];

const PHONES = [
  { label: "0202035183", href: "tel:0202035183" },
  { label: "+254723934728", href: "tel:+254723934728" },
  { label: "+254728229631", href: "tel:+254728229631" },
];

const CSS = `
@import url("https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&family=Young+Serif&display=swap");

.ft {
  --ft-bg: #0a2f36;
  --ft-bg-deep: #072229;
  --ft-text: rgba(255, 255, 255, 0.82);
  --ft-mint: #8fd3d0;
  --ft-line: rgba(255, 255, 255, 0.14);
  font-family: "Figtree", system-ui, -apple-system, "Segoe UI", sans-serif;
  background: var(--ft-bg);
  color: var(--ft-text);
}
.ft *, .ft *::before, .ft *::after { box-sizing: border-box; }
.ft-wrap { max-width: 72rem; margin: 0 auto; padding-left: clamp(1rem, 4vw, 2.5rem); padding-right: clamp(1rem, 4vw, 2.5rem); }

/* Top bar */
.ft-top { background: var(--ft-bg-deep); border-bottom: 1px solid var(--ft-line); }
.ft-top .ft-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.9rem;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  text-align: center;
}
@media (min-width: 48rem) { .ft-top .ft-wrap { flex-direction: row; justify-content: space-between; text-align: left; } }
.ft-follow { margin: 0; color: #fff; font-family: "Young Serif", Georgia, serif; font-size: clamp(1.15rem, 1rem + 0.7vw, 1.4rem); }
.ft-social { display: flex; gap: 0.6rem; }
.ft-social a {
  width: 2.75rem;
  height: 2.75rem;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}
.ft-social a:hover { background: #fff; color: var(--ft-bg); border-color: #fff; }

/* Main grid */
.ft-main { padding-top: clamp(2.5rem, 6vw, 4.5rem); padding-bottom: clamp(2.5rem, 6vw, 4rem); }
.ft-grid { display: grid; gap: clamp(2rem, 4vw, 3rem); grid-template-columns: 1fr; }
@media (min-width: 40rem) {
  .ft-grid { grid-template-columns: 1fr 1fr; }
  .ft-about { grid-column: 1 / -1; }
}
@media (min-width: 64rem) {
  .ft-grid { grid-template-columns: 5fr 3fr 4fr; }
  .ft-about { grid-column: auto; }
}

.ft-heading { margin: 0 0 1.1rem; color: #fff; font-family: "Young Serif", Georgia, serif; font-weight: 400; font-size: 1.25rem; line-height: 1.2; }
.ft-text { margin: 0 0 0.85rem; line-height: 1.7; max-width: 62ch; text-wrap: pretty; }
.ft-tagline { margin: 0; font-style: italic; color: var(--ft-mint); }

.ft-list { list-style: none; margin: 0; padding: 0; display: grid; gap: 0.35rem; }
.ft-link { color: var(--ft-text); text-decoration: none; overflow-wrap: anywhere; }
.ft-link:hover { color: #fff; text-decoration: underline; text-underline-offset: 3px; }

.ft-nav a {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  min-height: 2.75rem;
}
.ft-nav i { color: var(--ft-mint); font-size: 0.8rem; transition: transform 0.2s ease; }
.ft-nav a:hover i { transform: translateX(3px); }

.ft-contact { gap: 1rem; }
.ft-contact li { display: flex; gap: 0.9rem; align-items: flex-start; line-height: 1.55; }
.ft-icon {
  flex: none;
  width: 2.25rem;
  height: 2.25rem;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.09);
  color: var(--ft-mint);
  font-size: 0.9rem;
}
.ft-contact li > span:last-child, .ft-contact li > div { padding-top: 0.3rem; min-width: 0; }
.ft-phones { display: flex; flex-direction: column; gap: 0.15rem; }
.ft-phones a { display: inline-block; padding: 0.15rem 0; }

/* Bottom bar */
.ft-bottom { border-top: 1px solid var(--ft-line); }
.ft-bottom .ft-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding-top: 1.1rem;
  padding-bottom: calc(1.1rem + env(safe-area-inset-bottom, 0px));
  text-align: center;
  font-size: 0.92rem;
}
.ft-credit { margin: 0; }
.ft-credit a {
  color: #fff;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: var(--ft-mint);
  text-decoration-thickness: 2px;
  text-underline-offset: 4px;
  padding: 0.35rem 0.1rem;
  transition: color 0.2s ease;
}
.ft-credit a:hover { color: var(--ft-mint); }
.ft-credit i { color: var(--ft-mint); margin-right: 0.4rem; font-size: 0.85em; }
@media (min-width: 40rem) {
  .ft-bottom .ft-wrap { flex-direction: row; flex-wrap: wrap; justify-content: space-between; text-align: left; }
  /* Tablet: copyright and button share row one, credit centred below */
  .ft-credit { order: 3; flex: 1 1 100%; text-align: center; }
}
@media (min-width: 64rem) {
  /* Desktop: copyright left, credit centred, button right */
  .ft-bottom .ft-wrap { display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; }
  .ft-credit { order: 0; text-align: center; }
  .ft-top-btn { justify-self: end; }
}
.ft-top-btn {
  font: inherit;
  font-weight: 500;
  color: #fff;
  background: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  border-radius: 999px;
  padding: 0.55rem 1.15rem;
  min-height: 2.75rem;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.ft-top-btn:hover { background: #fff; color: var(--ft-bg); }

.ft .visually-hidden { position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0; }

.ft :is(a, button):focus-visible { outline: 3px solid #f0b429; outline-offset: 3px; border-radius: 0.35rem; }
.ft-social a:focus-visible, .ft-top-btn:focus-visible { border-radius: 999px; }
.ft-social a:focus-visible { border-radius: 50%; }

@media (prefers-reduced-motion: reduce) {
  .ft-social a, .ft-top-btn, .ft-nav i, .ft-credit a { transition: none; }
  .ft-nav a:hover i { transform: none; }
}
`;

export default function Footer() {
  return (
    <footer className="ft">
      <style>{CSS}</style>

      {/* Social bar */}
      <section className="ft-top" aria-label="Social media">
        <div className="ft-wrap">
          <p className="ft-follow">Follow us and stay connected!</p>
          <div className="ft-social">
            <a
              href="https://web.facebook.com/yayadental"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Yaya Dental Clinic on Facebook"
            >
              <i className="fab fa-facebook-f" aria-hidden="true"></i>
            </a>
            {/* <a
              href="https://www.linkedin.com/company/yaya-dental-clinic/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Yaya Dental Clinic on LinkedIn"
            >
              <i className="fab fa-linkedin-in" aria-hidden="true"></i>
            </a> */}
          </div>
        </div>
      </section>

      {/* Main content */}
      <div className="ft-wrap ft-main">
        <div className="ft-grid">
          <div className="ft-about">
            <h2 className="ft-heading">Yaya Dental Clinic</h2>
            <p className="ft-text">
              Our dedicated team of experienced professionals is committed to
              providing personalized care and exceptional service. We offer a
              comprehensive range of dental services to help you achieve a
              healthy and beautiful smile. Experience the difference of our
              compassionate approach, state-of-the-art facilities, and a
              welcoming atmosphere today.
            </p>
            <p className="ft-text ft-tagline">
              Start your journey towards a radiant smile now!
            </p>
          </div>

          <nav aria-label="Quick links">
            <h2 className="ft-heading">Quick links</h2>
            <ul className="ft-list ft-nav">
              {QUICK_LINKS.map((item) => (
                <li key={item.label}>
                  {item.to ? (
                    <Link className="ft-link" to={item.to}>
                      <i className="fa-solid fa-angle-right" aria-hidden="true"></i>
                      {item.label}
                    </Link>
                  ) : (
                    <a className="ft-link" href={item.href}>
                      <i className="fa-solid fa-angle-right" aria-hidden="true"></i>
                      {item.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="ft-heading">Contact us</h2>
            <ul className="ft-list ft-contact">
              <li>
                <span className="ft-icon" aria-hidden="true">
                  <i className="fa-solid fa-location-dot"></i>
                </span>
                <span>At Yaya Center, Nairobi 3rd Floor, Suite Number 8</span>
              </li>
              <li>
                <span className="ft-icon" aria-hidden="true">
                  <i className="fa-solid fa-clock"></i>
                </span>
                <span>Mon to Sat: 8am to 6pm</span>
              </li>
              <li>
                <span className="ft-icon" aria-hidden="true">
                  <i className="fa-regular fa-clock"></i>
                </span>
                <span>Sundays: On special arrangements</span>
              </li>
              <li>
                <span className="ft-icon" aria-hidden="true">
                  <i className="fa-solid fa-phone"></i>
                </span>
                <div className="ft-phones">
                  {PHONES.map((p) => (
                    <a key={p.href} className="ft-link" href={p.href}>
                      {p.label}
                    </a>
                  ))}
                </div>
              </li>
              <li>
                <span className="ft-icon" aria-hidden="true">
                  <i className="fa-solid fa-envelope"></i>
                </span>
                <span>
                  <a className="ft-link" href={`mailto:${CONTACT_EMAIL}`}>
                    {CONTACT_EMAIL}
                  </a>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright bar */}
      <div className="ft-bottom">
        <div className="ft-wrap">
          <small>
            &copy; {new Date().getFullYear()} Yaya Dental Clinic. All rights
            reserved.
          </small>
          <p className="ft-credit">
            <i className="fa-solid fa-code" aria-hidden="true"></i>
            Designed and built by{" "}
            <a href={CREDIT_URL} target="_blank" rel="noopener noreferrer">
              {CREDIT_NAME}
              <span className="visually-hidden"> (opens in a new tab)</span>
            </a>
          </p> 
          <button
            type="button"
            className="ft-top-btn"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <i className="fa-solid fa-arrow-up me-1" aria-hidden="true"></i>
            Back to top
          </button>
        </div>
      </div>
    </footer>
  );
}